export default __webpack_public_path__ + "static/media/code.d399b4a6.svg";